

export class DeviceModelAddInput implements IDeviceModelAddInput {
    /** The auto-generated id of the device brand master */
    deviceBrandId!: number;
    /** The device model name with 255 character limit */
    deviceName!: string;
    /** The device model name with 255 character limit */
    protocol!: string;
    /** The device model port with 100 character limit */
    port!: string;

    constructor(data?: IDeviceModelAddInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceBrandId = _data["deviceBrandId"];
            this.deviceName = _data["deviceName"];
            this.protocol = _data["protocol"];
            this.port = _data["port"];
        }
    }

    static fromJS(data: any): DeviceModelAddInput {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceModelAddInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceBrandId"] = this.deviceBrandId;
        data["deviceName"] = this.deviceName;
        data["protocol"] = this.protocol;
        data["port"] = this.port;
        return data; 
    }
}

export interface IDeviceModelAddInput {
    /** The auto-generated id of the device brand master */
    deviceBrandId: number;
    /** The device model name with 255 character limit */
    deviceName: string;
    /** The device model name with 255 character limit */
    protocol: string;
    /** The device model port with 100 character limit */
    port: string;
}

